import React from 'react';

import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import { type ChatAction, HandleActionType } from '@atlassian/conversation-assistant';
import type { NudgeRecommendationDetails } from '@atlassian/convo-ai-api';

export const buildConversationStarter = (
	recommendation: NudgeRecommendationDetails,
): ChatAction => ({
	id: 'convo-starter',
	title: recommendation.cta.cta_label ?? '',
	icon: () => <AiChatIcon label="" />,
	type: 'convo-starter-action',
	staticPrompt: recommendation.cta.cta_label ?? '',
	starterType: 'static',
	handleType: HandleActionType.Chat,
});
